export const NEW_NODE_NAME = "New Node";
